import Vue from 'vue';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

Vue.component('about-page', {
    data() {
        return {
            aboutVideoBackground: null,
            aboutVideoContainer: null,
            aboutVideo: null,
            aboutVideoFullscreenButton: null,
            aboutVideoCloseButton: null,
            aboutVideoMuteButton: null,
        };
    },

    mounted() {
        setTimeout(() => {
            this.initVideo();
        }, 800);

        this.toggleMute = (value) => {
            this.aboutVideo.muted = value;
        };

        EventBus.$on('toggleMute', this.toggleMute);
    },

    beforeDestroy() {
        EventBus.$on('toggleMute', this.toggleMute);
    },

    methods: {
        initVideo() {
            this.aboutVideoBackground = document.querySelector('.about__video-background');
            this.aboutVideoContainer = document.querySelector('.about__video-container');
            this.aboutVideo = document.querySelector('.about__video');
            this.aboutVideoFullscreenButton = document.querySelector('.about__video-fullscreen');
            this.aboutVideoCloseButton = document.querySelector('.about__video-close');
            this.aboutVideoCloseButtonIcon = document.querySelector('.about__video-close-icon');
            this.aboutVideoMuteButton = document.querySelector('.about__video-mute');
            this.aboutVideoReplayButton = document.querySelector('.about__video-replay');

            const isMobile = window.innerWidth < 768;
            this.toggleVideoFullscreen('add', 0);
            if (!isMobile) {
                console.log('Not mobile');
                // ScrollTrigger.create({
                //     trigger: this.aboutVideoBackground,
                //     start: 'top top',
                //     onEnter: () => this.toggleVideoFullscreen('add'),
                //     onLeaveBack: () => this.toggleVideoFullscreen('remove'),
                // });
            }

            this.aboutVideoFullscreenButton.addEventListener('click', () => {
                if (isMobile) {
                    console.log('Is Mobile');
                    this.aboutVideo.controls = true;
                    this.aboutVideo.playsInline = false;
                    EventBus.$emit('set-mute', false);

                    gsap.set(this.aboutVideoBackground, { backgroundColor: 'transparent', pointerEvents: 'initial' });

                    setTimeout(() => {
                        if (this.aboutVideo.requestFullscreen) {
                            this.aboutVideo.requestFullscreen();
                        } else if (this.aboutVideo.mozRequestFullScreen) {
                            this.aboutVideo.mozRequestFullScreen();
                        } else if (this.aboutVideo.webkitEnterFullscreen) {
                            this.aboutVideo.webkitEnterFullscreen();
                        } else if (this.aboutVideo.msRequestFullscreen) {
                            this.aboutVideo.msRequestFullscreen();
                        }
                    }, 250);

                    return;
                }

                if (this.aboutVideoContainer.classList.contains('fixed')) {
                    this.toggleVideoModal();
                }
            });

            this.aboutVideo.addEventListener('webkitendfullscreen', () => {
                EventBus.$emit('set-mute', true);
                this.aboutVideo.controls = false;
                this.aboutVideo.playsInline = true;
                console.log('webkitendfullscreen');
                try {
                    setTimeout(() => {
                        this.aboutVideo.play();
                    }, 1000);
                } catch (error) {
                    console.log(error);
                }
            });

            document.addEventListener('fullscreenchange', () => {
                if (!document.fullscreenElement) {
                    EventBus.$emit('set-mute', true);
                    this.aboutVideo.controls = false;
                    this.aboutVideo.playsInline = true;
                    console.log('fullscreenchange');
                    try {
                        setTimeout(() => {
                            this.aboutVideo.play();
                        }, 1000);
                    } catch (error) {
                        console.log(error);
                    }
                }
            });

            this.aboutVideoCloseButton.addEventListener('click', () => {
                this.toggleVideoFullscreen('add');
            });

            enableBodyScroll(this.aboutVideoBackground);
            EventBus.$emit('set-mute', true);

            setTimeout(() => {
                this.aboutVideo.play();
            }, 250);

            if (isMobile) {
                console.log('Going mobile');

                gsap.set(this.aboutVideoBackground, { backgroundColor: 'transparent', pointerEvents: 'none' });
                gsap.set(this.aboutVideoFullscreenButton, { autoAlpha: 1 });
                gsap.set(this.aboutVideoReplayButton, { autoAlpha: 0 });
                gsap.to(this.aboutVideoContainer, {
                    width: '158px',
                    height: '89px',
                    bottom: '20px',
                    right: '20px',
                    transform: 'translate(0, 0)',
                });
                gsap.to(this.aboutVideoCloseButton, {
                    autoAlpha: 0,
                    scale: 0,
                });
                gsap.to(this.aboutVideoCloseButtonIcon, {
                    autoAlpha: 0,
                });
                gsap.to(this.aboutVideoMuteButton, {
                    autoAlpha: 0,
                });
            }
        },

        onCloseClick() {
            this.toggleVideoFullscreen('close');
        },

        replayVideo() {
            this.aboutVideo.currentTime = 0;
            this.aboutVideo.play();
        },

        toggleVideoFullscreen(action, timescale = 0.5) {
            this.aboutVideoContainer.classList.add('fixed');

            const tablet = window.innerWidth >= 768;

            console.log('timescale', timescale);

            if (action === 'remove') {
                // disableBodyScroll(this.aboutVideoBackground);
                // this.aboutVideo.muted = true;
                console.log('remove');

                const tl = gsap.timeline({
                    timescale,
                });

                tl.set(this.aboutVideoBackground, { backgroundColor: 'transparent', pointerEvents: 'none' });
                tl.set(this.aboutVideoFullscreenButton, { autoAlpha: 0 });
                tl.set(this.aboutVideoReplayButton, { autoAlpha: 1 });
                tl.to(this.aboutVideoContainer, {
                    width: '100%',
                    height: '100%',
                    bottom: '0px',
                    right: '0px',
                    transform: 'translate(0, 0)',
                    ease: 'power2.inOut',
                    duration: 0.5,
                });
                tl.to(this.aboutVideoCloseButton, {
                    autoAlpha: 1,
                    scale: 1,
                    duration: 0.4,
                    ease: 'power2.inOut',
                }, '<');
                tl.to(this.aboutVideoCloseButtonIcon, {
                    autoAlpha: 1,
                    duration: 0.2,
                    ease: 'power2.inOut',
                }, '<');
                tl.to(this.aboutVideoMuteButton, {
                    autoAlpha: 1,
                }, '<');

                return;
            }

            if (action === 'add') {
                enableBodyScroll(this.aboutVideoBackground);
                EventBus.$emit('set-mute', true);

                const tl = gsap.timeline({
                    timescale,
                });

                tl.set(this.aboutVideoBackground, { backgroundColor: 'transparent', pointerEvents: 'none' });
                tl.set(this.aboutVideoFullscreenButton, { autoAlpha: 1 });
                tl.set(this.aboutVideoReplayButton, { autoAlpha: 0 });
                tl.to(this.aboutVideoContainer, {
                    width: tablet ? '18.541vw' : '158px',
                    height: tablet ? '10.4166vw' : '89px',
                    bottom: tablet ? '0.6944vw' : '20px',
                    right: tablet ? '0.6944vw' : '20px',
                    transform: 'translate(0, 0)',
                    ease: 'power2.inOut',
                    duration: 0.5,
                });
                tl.to(this.aboutVideoCloseButton, {
                    autoAlpha: 0,
                    scale: 0,
                    duration: 0.4,
                    ease: 'power2.inOut',
                }, '<');
                tl.to(this.aboutVideoCloseButtonIcon, {
                    autoAlpha: 0,
                    duration: 0.2,
                    ease: 'power2.inOut',
                }, '<');
                tl.to(this.aboutVideoMuteButton, {
                    autoAlpha: 0,
                }, '<');

                return;
            }

            if (action === 'close') {
                console.log('close');
                const tl = gsap.timeline({
                    timescale,
                });

                tl.set(this.aboutVideoBackground, { backgroundColor: 'transparent', pointerEvents: 'none' });
                tl.set(this.aboutVideoFullscreenButton, { autoAlpha: 1 });
                tl.set(this.aboutVideoReplayButton, { autoAlpha: 0 });
                tl.to(this.aboutVideoContainer, {
                    width: tablet ? '18.541vw' : '158px',
                    height: tablet ? '10.4166vw' : '89px',
                    bottom: tablet ? '0.6944vw' : '20px',
                    right: tablet ? '0.6944vw' : '20px',
                    transform: 'translate(0, 0)',
                    ease: 'power2.inOut',
                    duration: 0.5,
                });
                tl.to(this.aboutVideoCloseButton, {
                    autoAlpha: 0,
                    scale: 0,
                    duration: 0.4,
                    ease: 'power2.inOut',
                }, '<');
                tl.to(this.aboutVideoCloseButtonIcon, {
                    autoAlpha: 0,
                    duration: 0.2,
                    ease: 'power2.inOut',
                }, '<');
                tl.to(this.aboutVideoMuteButton, {
                    autoAlpha: 0,
                }, '<');
            }
        },

        toggleVideoModal() {
            disableBodyScroll(this.aboutVideoBackground);

            console.log('Video modal is not implemented yet.');
            this.aboutVideoContainer.classList.remove('fixed');
            this.aboutVideoContainer.classList.add('modal');

            if (this.aboutVideo.muted) {
                EventBus.$emit('set-mute', false);
            }

            gsap.set(this.aboutVideoBackground, { pointerEvents: 'all' });

            const tl = gsap.timeline();

            tl.set(this.aboutVideoFullscreenButton, { autoAlpha: 0 });
            tl.set(this.aboutVideoReplayButton, { autoAlpha: 1 });
            tl.set(this.aboutVideoBackground, { backgroundColor: 'rgba(0, 0, 0, 0.7)' });
            tl.to(this.aboutVideoContainer, {
                width: '80vw',
                height: '45vw',
                right: '50%',
                bottom: '50%',
                xPercent: 50,
                yPercent: 50,
            });
            tl.to(this.aboutVideoCloseButton, {
                autoAlpha: 1,
                scale: 1,
                duration: 0.4,
                ease: 'power2.inOut',
            }, '<');
            tl.to(this.aboutVideoCloseButtonIcon, {
                autoAlpha: 1,
                duration: 0.2,
                ease: 'power2.inOut',
            }, '<');
            tl.to(this.aboutVideoMuteButton, {
                autoAlpha: 1,
            }, '<');
        },
    },
});
